export const STAY = 'STAY';
export const LEAVE = 'LEAVE';
